import { useMemo } from 'react';

import { parseDocsSession, updateDocsSession } from '../api/docs-session';
import { DOCS_SESSION_KEY } from '../api/docs-storage';

import { useBrowserStorage } from './use-browser-storage';

export type { DocsCustomer, DocsSession, RememberedValue } from '../schemas/docs-storage-schema';

const clearCustomer = () => updateDocsSession((session) => ({ ...session, customer: null }));
const confirmPayments = () =>
  updateDocsSession((session) => ({ ...session, paymentConfirmed: true }));

/**
 * The playground session of this tab (`sessionStorage`): the signed-in customer whose token
 * customer routes send, the last Idempotency-Key, and values remembered from responses.
 */
export function useDocsSession() {
  const raw = useBrowserStorage('session', DOCS_SESSION_KEY);
  const session = useMemo(() => parseDocsSession(raw), [raw]);
  return { ...session, update: updateDocsSession, clearCustomer, confirmPayments };
}
